// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SleepIconInline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 65 65" {...props}>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="SleepIconInline_tsx__a">
				<stop stopColor="#75B2F0" offset="0%" />
				<stop stopColor="#B275F0" offset="100%" />
			</linearGradient>
		</defs>
		<g transform="translate(-.5 -.967)" fill="none" fillRule="evenodd">
			<circle fill="url(#SleepIconInline_tsx__a)" cx={32.5} cy={32.967} r={32} />
			<path
				d="M32.552 45.311c-5.082 0-9.703-3.194-11.5-7.948a.607.607 0 0 1 .763-.79 11.03 11.03 0 0 0 3.576.594c6.11 0 11.08-4.97 11.08-11.079 0-1.344-.241-2.661-.715-3.914a.607.607 0 0 1 .763-.789 12.29 12.29 0 0 1 8.325 11.634c0 6.778-5.514 12.292-12.292 12.292"
				fill="#FFF"
			/>
		</g>
	</svg>
);
export default SleepIconInline;
